// ==============================================================
// 📈 TopicsTrend.jsx — Tópicos mais discutidos recentemente
// ==============================================================

import React, { useEffect, useState } from "react";
import { listenAllMessages } from "../../../services/iaDashboard/messagesService";
import { extractTopics } from "../../../services/iaDashboard/insightsService";

export default function TopicsTrend() {
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    const unsub = listenAllMessages((messages) => {
      setTopics(extractTopics(messages || []));
    });

    return () => unsub && unsub();
  }, []);

  return (
    <div className="ia-insight-card">
      <div className="ia-insight-title">Tendências de Tópicos</div>

      {topics.length === 0 && (
        <p className="ia-chart-empty">Nenhum tópico detectado ainda.</p>
      )}

      {topics.map((t, i) => (
        <div key={i} className="ia-realtime-feed-item">
          <strong style={{ color: "#c2185b" }}>{t.topic}:</strong>{" "}
          {t.count} citações
        </div>
      ))}
    </div>
  );
}
